// extracted by mini-css-extract-plugin
export default {"container":"DonationView_container__dFNT2"};